import { Heading } from '@etg/wings';
import { cx } from '@eti/styles';
import { useDirection } from '@eti/providers';
import { useProductCardContext } from '../../context/ProductCardContext';
import { getProductPictogramId } from '../../utils/icon/getProductImageryIds';
import UpSell from '../../components/ProductUpSell';
import { usePictogram } from '../../utils/useIllustration';
import { headerWrapperStyles, pictogramStyles, standardGrid, titleStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Header = _ref => {
  let {
    customGrid,
    children,
    className
  } = _ref;
  const {
    isRTL
  } = useDirection();
  const {
    upSell,
    shouldDisplayUpsell,
    title,
    productName
  } = useProductCardContext();
  const pictogramUrl = usePictogram(productName);
  if (!upSell && !pictogramUrl && !title && !children) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: cx(headerWrapperStyles, className, customGrid || standardGrid),
    "data-testid": `header-${productName}`,
    children: [shouldDisplayUpsell && (upSell === null || upSell === void 0 ? void 0 : upSell.content) && /*#__PURE__*/_jsx("div", {
      className: "upsell",
      children: /*#__PURE__*/_jsx(UpSell, {
        "data-testid": "upsell-text",
        upSell: upSell
      })
    }), pictogramUrl && /*#__PURE__*/_jsx("div", {
      className: cx(pictogramStyles(pictogramUrl), 'pictogram'),
      "data-testid": `${productName}-pictogram`,
      id: getProductPictogramId(productName, isRTL)
    }), title && /*#__PURE__*/_jsx(Heading, {
      className: cx(titleStyles, 'title'),
      level: 2,
      children: title
    }), children && /*#__PURE__*/_jsx("div", {
      className: "children",
      "data-testid": "header-children",
      children: children
    })]
  });
};
export default Header;
//# sourceMappingURL=Header.js.map